import { render, staticRenderFns } from "./injuryT.vue?vue&type=template&id=66ac9e5e&scoped=true&"
import script from "./injuryT.vue?vue&type=script&lang=js&"
export * from "./injuryT.vue?vue&type=script&lang=js&"
import style0 from "./injuryT.vue?vue&type=style&index=0&id=66ac9e5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac9e5e",
  null
  
)

export default component.exports